import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import CompanyRepository from '@/shared/http/repositories/configuration/company'
import GroupRepository from '@/shared/http/repositories/access/group'
import AccountRepository from '@/shared/http/repositories/access/account'
import AccountModel from '@/shared/models/access/accountmodel'
import AccountForms from './account-form'
import { debounce } from 'lodash'

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export default {
  name: 'Account',
  mixins: [ActionsForm],
  data () {
    return {
      data: AccountModel,
      form: AccountForms,
      nameSearch: ''
    }
  },
  components: {
    AutocompleteZ
  },
  created () {
    this.onClear()
  },
  mounted () {
    this.onLoadAllCompany()
    this.onLoadAllGroup()
  },
  watch: {
    nameSearch: debounce(function () {
      this.onLoad()
    }, 800)
  },
  methods: {
    onLoad () {
      if (this.nameSearch) {
        loading.push()
        AccountRepository.GetAllPagingByName(this.nameSearch, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        loading.push()
        AccountRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onClear () {
      ActionsForm.methods.onClear.call(this)
      if (this.$refs.funcionarioTypeahead) {
        this.$refs.funcionarioTypeahead.clear()
      }
    },
    onSelect (obj) {
      this.$refs.txtAccountName.focus()
      this.onEdit(obj)
      this.onLoadFuncionario(obj.funcionarioID)
    },
    onLoadFuncionario (funcionarioID) {
      if (!funcionarioID || funcionarioID === EMPTY_GUID) {
        this.form.funcionarioID.value = null
        this.$refs.funcionarioTypeahead.clear()
        return
      }
      loading.push()
      EmployeeRepository.GetResponsibleById(funcionarioID)
        .then((response) => {
          if (response.data.code > 0 && response.data.data && response.data.data.length > 0) {
            this.$refs.funcionarioTypeahead.setValue(response.data.data[0])
          } else {
            this.form.funcionarioID.value = null
            this.$refs.funcionarioTypeahead.clear()
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onCreate () {
      loading.push()
      if (!this.data.senha) {
        this.onException(new Error('Para criar uma conta é necessário informar a senha!'))
      }
      this.data.senha = this.data.senha.toString()
      this.data.enviaEmail = false
      AccountRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      this.data.status = parseInt(this.data.status)
      AccountRepository.Update(this.data)
        .then((response) => { this.onResult(response) })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      AccountRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCompany () {
      loading.push()
      CompanyRepository.GetAll()
        .then((response) => {
          this.form.empresaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllGroup () {
      loading.push()
      GroupRepository.GetAll()
        .then((response) => {
          this.form.grupoID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCheckUsername () {
      var username = this.form.username.value
      loading.push()
      AccountRepository.GetByUsername(username)
        .then((response) => {
          if (response) {
            if (response.data.data) {
              var obj = response.data.data
              if (obj) {
                toast.warning(this.$lang.Accounts.AlertUsernameExisted)
                this.form.username.value = null
                this.$refs.CompUsername.$el.focus()
              }
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSearchFuncionario (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.funcionarioTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFuncionario (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.funcionarioTypeahead.setValue(response.data.data[0])
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/account/account.js